import "./TrendingModal.css";

/**
 * 가장 많은 사람이 서재에 담은 책 7권.
 *
 * 예전에는 최근 7일 안에 담긴 횟수를 셌다. 그런데 화면에는 "1명" 이라고만
 * 뜨어서, 책을 열면 독자가 2명인데 목록은 1명이라 어긋나 보였다.
 * 기간을 좁혀 세는 값과 전체 독자 수는 다른 값인데 같은 모양으로 보였다.
 *
 * 전체 기간으로 바꾼다. 표시만 바꾸면 1위가 3명, 2위가 12명처럼 뒤집혀
 * 보이므로 순위 기준도 함께 바꾼다.
 *
 * '지금 새로 들어온 책' 은 "🔥 최근 7일" 배지가 따로 맡는다.
 */
const LIMIT = 7;

export function getTrendingBooks(allBooks) {
  return (allBooks || [])
    .map((book) => ({ book, count: Object.keys(book.registeredBy || {}).length }))
    .filter((x) => x.count > 0)
    .sort(
      (a, b) =>
        b.count - a.count ||
        // 동수면 순서가 무작위라 볼 때마다 자리가 바뀐다
        a.book.title.localeCompare(b.book.title)
    )
    .slice(0, LIMIT);
}

const TrendingModal = ({ allBooks, onClose, onBookClick }) => {
  const items = getTrendingBooks(allBooks);

  return (
    <div
      className="trending-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="trending-modal" role="dialog" aria-label="많이 담은 책">
        <div className="trending-head">
          <div>
            <div className="trending-title">많이 담은 책</div>
            <div className="trending-sub">지금까지 서재에 담은 사람 수</div>
          </div>
          <button className="trending-close" onClick={onClose} aria-label="닫기">✕</button>
        </div>

        {items.length === 0 ? (
          <div className="trending-empty">
            아직 담긴 책이 없어요.
          </div>
        ) : (
          <ol className="trending-list">
            {items.map(({ book, count }, i) => (
              <li
                key={book.id}
                className="trending-item"
                style={{ animationDelay: `${i * 0.05}s` }}
                onClick={() => { onClose(); if (onBookClick) onBookClick(book.id); }}
              >
                <span className="trending-rank">{i + 1}</span>
                <div className="trending-cover">
                  {book.cover
                    ? <img src={book.cover} alt="" />
                    : <span>📖</span>}
                </div>
                <div className="trending-info">
                  <div className="trending-book-title">{book.title}</div>
                  <div className="trending-book-author">{book.author}</div>
                </div>
                <div className="trending-count">
                  <span className="trending-count-num">{count}</span>
                  <span className="trending-count-label">명 담음</span>
                </div>
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
};

export default TrendingModal;
